import React from 'react';
import { getContainerStyle, getGridStyle } from './grid-options';
import styles from './grid.scss';
export const Grid = _ref => {
  let {
    items,
    layout,
    isRTL
  } = _ref;
  const reactElementsByRow = getReactElementsByRow(items);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container,
    dir: isRTL ? 'rtl' : '',
    style: getContainerStyle(layout)
  }, reactElementsByRow.map((elements, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      style: getGridStyle(layout),
      className: styles.grid
    }, elements);
  }));
};
function getReactElementsByRow(items) {
  const reactElementsByRow = items.reduce((result, item) => {
    const row = item.layout.row;
    const element = /*#__PURE__*/React.cloneElement(item.component, {
      key: item.id
    });
    if (result[row]) {
      result[row].push(element);
    } else {
      result[row] = [element];
    }
    return result;
  }, []);
  return reactElementsByRow;
}
//# sourceMappingURL=grid.js.map